import React from "react";
import abimg from "./careers.jpg";
import { Link } from "react-router-dom";
import { Box, Container, Grid, Typography, Button, Paper } from "@mui/material";
import { motion } from "framer-motion";
import GroupsIcon from "@mui/icons-material/Groups";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import WorkIcon from "@mui/icons-material/Work";

const Careers = () => {
  const ClickHandler = () => window.scrollTo(10, 0);

  const perks = [
    { icon: <GroupsIcon />, title: "Collaborative Culture" },
    { icon: <TrendingUpIcon />, title: "Growth Opportunities" },
    { icon: <WorkIcon />, title: "Diverse Projects" },
  ];

  return (
    <Box
      component="section"
      sx={{ py: { xs: 4, md: 7 }, bgcolor: "#fff", overflow: "hidden" }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={8} alignItems="center">
          <Grid item xs={12} lg={6}>
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <Box sx={{ position: "relative" }}>
                <Box
                  sx={{
                    position: "absolute",
                    top: -20,
                    left: -20,
                    width: "100%",
                    height: "100%",
                    border: "2px solid var(--primary-color)",
                    borderRadius: "30px",
                    zIndex: 0,
                  }}
                />
                <Paper
                  elevation={20}
                  sx={{
                    borderRadius: "30px",
                    overflow: "hidden",
                    position: "relative",
                    zIndex: 1,
                  }}
                >
                  <img
                    src={abimg}
                    alt="Work at V Doogar"
                    style={{
                      width: "100%",
                      height: "auto",
                      display: "block",
                      filter: "brightness(0.95)",
                    }}
                  />
                </Paper>
              </Box>
            </motion.div>
          </Grid>

          <Grid item xs={12} lg={6}>
            <Box>
              <Typography
                variant="overline"
                sx={{
                  color: "var(--primary-color)",
                  fontWeight: 800,
                  letterSpacing: 2,
                  mb: 1,
                  display: "block",
                }}
              >
                Join Our Team
              </Typography>
              <Typography
                variant="h2"
                sx={{
                  fontWeight: 800,
                  color: "#222",
                  fontFamily: "'Roboto Slab', serif",
                  fontSize: { xs: "2.2rem", md: "3rem" },
                  mb: 3,
                  lineHeight: 1.2,
                }}
              >
                Step Into a Career of{" "}
                <span style={{ color: "var(--primary-color)" }}>
                  Impact & Growth
                </span>
              </Typography>
              <Typography
                sx={{
                  color: "#666",
                  fontSize: "1.1rem",
                  lineHeight: 1.8,
                  mb: 4,
                  textAlign: "justify",
                }}
              >
                We are searching for passionate, talented individuals who want
                to redefine the consulting landscape. Whether you are an
                experienced professional or a rising star, we provide the
                platform to build the future of global business.
              </Typography>

              <Grid container spacing={2} sx={{ mb: 5 }}>
                {perks.map((perk, index) => (
                  <Grid
                    item
                    xs={12}
                    sm={4}
                    key={index}
                    sx={{ display: "flex" }}
                  >
                    <Box
                      sx={{
                        textAlign: "center",
                        p: 2,
                        bgcolor: "#f8f9fa",
                        borderRadius: "16px",
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Box sx={{ color: "var(--primary-color)", mb: 1 }}>
                        {perk.icon}
                      </Box>
                      <Typography
                        sx={{
                          fontWeight: 600,
                          fontSize: "0.85rem",
                          color: "#333",
                        }}
                      >
                        {perk.title}
                      </Typography>
                    </Box>
                  </Grid>
                ))}
              </Grid>

              <Link
                onClick={ClickHandler}
                to="/currentOpenings"
                style={{
                  textDecoration: "none",
                }}
              >
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "var(--primary-color)",
                    px: 6,
                    py: 2,
                    borderRadius: "50px",
                    fontWeight: 800,
                    fontSize: "1rem",
                    textTransform: "none",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
                    "&:hover": {
                      bgcolor: "#143380",
                    },
                  }}
                >
                  Explore Current Openings
                </Button>
              </Link>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Careers;
